import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import numeral from "numeral";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { AutoSizer, List } from "react-virtualized";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagic,
  faChartLine,
  faCheckCircle,
  faMapMarker,
  faTrash,
  faComments,
  faBullseye,
  faPlay,
  faSortAlphaDown,
  faSortNumericDown
} from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup, Icon, Accordion } from "aible";

import { getSummary } from "utils/stats";

import { VIEW_TYPE } from "containers/View/reducer";

import NodePin from "images/Next-Icons/NodePin.svg";
import ExitIcon from "images/Next-Icons/ExitIcon.svg";
import FullPin from "images/Next-Icons/FullPin.svg";
import TodoFeedbackIcon from "images/Next-Icons/TodoFeedbackIcon.svg";
import TodoAssignIcon from "images/Next-Icons/TodoAssignIcon.svg";
import NextClose from "images/Next-Icons/NextClose.svg";

import PinnedIcon from "images/Sense-Icons/pinned.svg";
import UnpinnedIcon from "images/Sense-Icons/unpinned.svg";
import PinnedHoverIcon from "images/Sense-Icons/unpin.svg";

import RadarIcon from "images/radar-light.svg";

import NextSearchContainer from "containers/Next/NextSearch";
import SmallDateChart from "components/Tiles/Sense/SmallDateChart";

import Heatmap from "components/Next/Charts/Heatmap";

import NextChartContainer from "components/Next/Charts/NextChart";
import DoubleOutcomeChartContainer from "containers/Next/Charts/DoubleOutcomeChart";
import OutcomeChartContainer from "containers/Next/Charts/OutcomeChart";
import LeakageChartContainer from "containers/Next/Charts/LeakageChart";
import ComparisonChartContainer from "containers/Next/Charts/ComparisonChart";

import SelectDataWrapperContainer from "containers/UnifiedProject/SelectData/SelectDataWrapper";

import MonitoringContainer from "containers/Monitoring/Monitoring";
import RelationTile from "components/Tiles/Sense/Relation/RelationTile";
import RealityCheckContainer from "containers/UnifiedProject/RealityCheck/RealityCheck";
import StrategyContainer from "containers/Business/Strategy/Strategy";
import BusinessConstraintsContainer from "containers/Business/Strategy/BusinessConstraints";

import GalleryContainer from "containers/Gallery/Gallery";

import * as nextReducer from "containers/Next/NextReducer";
import * as wizardReducer from "containers/Wizard/reducer";

import styles from "./style.module.css";
import DateRangeDisplay from "components/KPIAnalysis/DateRangeDisplay";

const colors = [
  "rgba(134, 134, 210, 1)",
  "rgba(223, 154, 80, 1)",
  "rgba(209, 106, 67, 1)",
  "rgba(161, 192, 100)",
  "rgba(102, 102, 102, 1)",
  "rgba(104, 168, 216, 1)"
];

export default class NextReport extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isSearchOpen: false,
      isTransformOpen: false,
      hasUpdatedComparisonOptions: false,
      tempComparisonOptions: { ...this.props.comparisonOptions },
      displayType: "CHART"
    };
  }

  /*
  componentDidUpdate(prevProps) {
    const { selectedHex } = this.props;

     const hKey =
       selectedHex === undefined ? "none" : selectedHex.x + "_" + selectedHex.y;

     const sDiv = document.getElementById("reportChart_" + hKey);

     if (sDiv) {
       sDiv.scrollIntoView();
     }
  }
*/

  renderMonitor() {
    const { id, datasetId, projectId, runId, selectedHex, selectedTransformNode, hasSplits } = this.props;

    const retProps = {
      id: projectId === undefined ? "new" : projectId,
      runId: projectId === undefined ? "new" : runId,
      datasetId: datasetId,
      isNext: true,
      isModelsNext: true,
      hideModel: true,
      hasSplits: hasSplits
    };

    return (
      <div
        className={styles.nextMonitoringPanel}
        style={
          hasSplits
            ? {
                width: "calc(100% - 50px)",
                marginLeft: "50px"
              }
            : {}
        }
        id="monitoringGallery"
      >
        <MonitoringContainer {...retProps} />
      </div>
    );
  }

  renderTransform() {
    const {
      id,
      datasetId,
      projectId,
      runId,
      selectedHex,
      updateSelectedHex,
      selectedTransformHex,
      updateSelectedTransformHex,
      selectedTransformNode,
      reportLabel,
      updateViewType
    } = this.props;

    const retProps = {
      id: projectId === undefined ? "new" : projectId,
      runId: projectId === undefined ? "new" : runId,
      datasetId: datasetId,
      isNext: true,
      isModelsNext: true,
      hideModel: true
    };

    return (
      <div
        className={styles.reportGallery}
        id="reportGallery"
        style={
          selectedTransformNode?.leftSection === "BLUEPRINT"
            ? { overflow: "auto", width: "100%", height: "100%" }
            : { width: "100%", height: "100%" }
        }
      >
        {selectedTransformNode ? (
          selectedTransformNode.leftSection === "OUTCOME" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              nextId={id}
              isNext
            />
          ) : selectedTransformNode.leftSection === "BLUEPRINT" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              isBlueprintPicker={true}
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              reportLabel={reportLabel}
              nextId={id}
              blueprintPickerHeader
              isNext
              onBlueprintSelect={() => updateSelectedTransformHex(selectedTransformHex, selectedTransformNode)}
            />
          ) : selectedTransformNode.leftSection === "BASELINE" ? (
            <RealityCheckContainer {...retProps} />
          ) : selectedTransformNode.leftSection === "STRATEGY" ? (
            <BusinessConstraintsContainer {...retProps} />
          ) : selectedTransformNode.leftSection === "EXPECTED" ? (
            <StrategyContainer {...retProps} />
          ) : selectedTransformNode.leftSection === "TRANSFORM" ? (
            <RelationTile
              datasetId={datasetId}
              forceIsOpen
              onSubmit={() => {
                updateViewType(VIEW_TYPE.DATASETS);
                history.push("/");
              }}
            />
          ) : (
            <GalleryContainer datasetId={datasetId} isNext isConsumer nextId={id} runId={runId} />
          )
        ) : (
          <GalleryContainer datasetId={datasetId} isNext isConsumer nextId={id} runId={runId} />
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      datasetId,
      actionHexMap,
      selectedChart,
      isTransform,
      activeTab,
      datasetSuccess,
      outcomeType,
      comparisonOptions,

      isOutcomeMulticategorical,
      defaultSuccess,

      isList,

      charts,
      isReportExpand,

      isHideSearch,
      scrollReportTitle,

      dataset,
      successOptions,
      datasetTargetValue,
      gridType,
      continuousGraphDisplayType,
      updateContinuousGraphDisplayType,
      updateDatasetSuccess,
      copyAndChangeDatasetSuccess,
      updateViewType
    } = this.props;

    const { isSearchOpen, isTransformOpen, isUpdateComparisonPeriod, sortType, tempComparisonOptions, displayType } =
      this.state;

    if (isTransform) {
      return this.renderTransform();
    }

    if (activeTab === "MONITOR") {
      return this.renderMonitor();
    }

    const isContinuous = outcomeType === "number";

    const updateIsUpdateComparisonPeriod = (val) => {
      this.setState({
        isUpdateComparisonPeriod: val
      });
    };

    const updateTempComparisonOptions = (val) => {
      this.setState({
        tempComparisonOptions: val
      });
    };

    const updateSortType = (val) => {
      this.setState({
        sortType: val
      });
    };

    const updateDisplayType = (val) => {
      this.setState({
        displayType: val
      });
    };

    const moreCharts = Object.keys(actionHexMap ?? {})
      .map((k) => ({
        ...actionHexMap[k],
        x: k.split("_")[0],
        y: k.split("_")[1]
      }))
      .filter((node) => node.type === "Second Order Chart" && node.chart);

    /*
    Why did we do it this way

    const pinnedHexHash = {};
    Object.keys(pinnedHex || {}).forEach((pKey) => {
      if (pKey?.chart?.title !== undefined)
        pinnedHexHash[selectedHex?.chart?.title] = true;
      charts.push({
        ...pinnedHex[pKey],
        chart: { ...pinnedHex[pKey], isAdded: true },
        hKey: pinnedHex[pKey].x + "_" + pinnedHex[pKey].y,
        x: pinnedHex[pKey].x,
        y: pinnedHex[pKey].y,
      });
    });

    (fullPinnedHexList || []).forEach((pKey) => {
      if (
        pKey?.chart?.title !== undefined &&
        !pinnedHexHash[selectedHex?.chart?.title]
      ) {
        charts.push({
          ...pKey,
          chart: { ...pKey, isAdded: true },
          hKey: pKey.x + "_" + pKey.y,
          x: pKey.x,
          y: pKey.y,
        });
      }
    });

    const selectedHexIsPinned =
      pinnedHex &&
      pinnedHex.length > 0 &&
      pinnedHex.find(
        (pin) => pin.x === selectedHex.x && pin.y === selectedHex.y
      );
    const recentPin = pinnedHex?.length > 0 && pinnedHex[pinnedHex.length - 1];

    if (selectedChart && pinnedHex?.[selectedChart.hKey] === undefined) {
      charts.push({
        chart: {
          chart: selectedChart.chart,
          type: selectedChart.type,
          fields: { ...selectedChart.fields },
        },
        fields: { ...selectedChart.fields },
        hKey: selectedChart.hKey,
        isTemporary: true,
        x: selectedChart.x,
        y: selectedChart.y,
        rIndex: selectedChart.rIndex,
        fromType: selectedChart.fromType,
        isPath: selectedChart.isPath,
        parent: selectedChart.parent
      });

      charts.push({
        chart: {
          chart: selectedChart.chart,
          type: selectedChart.type,
          fields: { ...selectedChart.fields },
        },
        fields: { ...selectedChart.fields },
        hKey: selectedChart.hKey,
        isFakeHidden: true,
        rIndex: selectedChart.rIndex,
        fromType: selectedChart.fromType,
        isPath: selectedChart.isPath,
        parent: selectedChart.parent
      });
    } else if (
      recentPin &&
      selectedHex?.chart?.title !== undefined &&
      recentPin.aParent?.chart?.title === selectedHex?.chart?.title
    ) {
      const key = recentPin.x + "_" + recentPin.y;
      charts.push({
        chart: { chart: recentPin.chart, type: recentPin.type },
        hKey: key,
        isTemporary: true,
      });

      charts.push({
        chart: { chart: recentPin.chart, type: recentPin.type },
        hKey: key,
        isFakeHidden: true,
      });
    } else if (
      selectedHex?.chart?.title !== undefined &&
      !selectedHexIsPinned
    ) {
      const key = selectedHex.x + "_" + selectedHex.y;
      charts.push({
        chart: { chart: selectedHex.chart, fields: { ...selectedHex.fields } },
        hKey: key,
        x: selectedHex.x,
        y: selectedHex.y,
        isTemporary: true,
      });

      charts.push({
        chart: { chart: selectedHex.chart, fields: { ...selectedHex.fields } },
        hKey: key,
        isFakeHidden: true,
      });
    }

    */

    const chartStyle = { height: "100%" };

    let retSuccessValue = undefined;

    const rawHasSuccessChanged = this.props.hasSuccessChanged;
    const hasSuccessChanged = isOutcomeMulticategorical && defaultSuccess !== datasetSuccess?.value;

    const foundSelectedChart =
      selectedChart !== undefined
        ? charts.find(
            (c) =>
              c?.chart?.narrative?.title !== undefined &&
              c?.chart?.narrative?.title === selectedChart?.chart?.narrative?.title
          )
        : undefined;

    const retCharts =
      foundSelectedChart === undefined && selectedChart !== undefined
        ? [...charts, { ...selectedChart, isTemporary: true }]
        : charts;

    let chartIndex;
    if (scrollReportTitle !== undefined) {
      if (isNaN(scrollReportTitle)) {
        const scrollTitleIndex = retCharts.findIndex((n) => {
          return scrollReportTitle === n?.chart?.title;
        });
        if (scrollTitleIndex >= 0) {
          chartIndex = scrollTitleIndex + 1;
        }
      } else {
        chartIndex = parseInt(scrollReportTitle);
      }
    }

    return (
      <div className={styles.nextReport} id={"reportScroll"}>
        {/*
        <div className={styles.searchButton}>
          <Button
            onClick={() => this.setState({ isSearchOpen: !isSearchOpen })}
            active={isSearchOpen}
          >
            {"Search"}
          </Button>
        </div>
        */}
        {isReportExpand !== true && isHideSearch !== true && (
          <NextSearchContainer
            id={id}
            datasetId={datasetId}
            isOpen={isSearchOpen}
            isTransformOpen={isTransformOpen}
            updateIsOpen={(isOpen) => this.setState({ isSearchOpen: isOpen })}
            updateIsTransformOpen={(isOpen) => this.setState({ isTransformOpen: isOpen })}
            isList={isList}
          />
        )}
        <div className={styles.chartList} id="reportChartList">
          <div style={isTransformOpen ? { height: "calc(100vh - 170px)" } : { display: "none" }}>
            <RelationTile
              datasetId={datasetId}
              onSubmit={() => this.setState({ isTransformOpen: false })}
              forceIsOpen
            />
          </div>

          <div className={styles.nextTitle}>
            <div className={styles.nextTitleText}>
              {comparisonOptions
                ? "Exploring What's Changed about " +
                  dataset?.outcome +
                  (successOptions?.find((option) => {
                    if (datasetSuccess?.value !== undefined) {
                      return option?.value === datasetSuccess?.value;
                    }
                    return option?.value === datasetTargetValue;
                  })?.value
                    ? ` is ${
                        successOptions?.find((option) => {
                          if (datasetSuccess?.value !== undefined) {
                            return option?.value === datasetSuccess?.value;
                          }
                          return option?.value === datasetTargetValue;
                        })?.value
                      }`
                    : "")
                : gridType === "Default"
                  ? "Exploring all insights about " +
                    dataset?.outcome +
                    (retSuccessValue !== undefined ? ` is ${retSuccessValue}` : "")
                  : gridType === "Reduced"
                    ? "The top 6 variables that affect " +
                      dataset?.outcome +
                      (retSuccessValue !== undefined ? ` is ${retSuccessValue}` : "")
                    : gridType === "ModelDriver"
                      ? "The top variables that affect my model"
                      : gridType === "Empty"
                        ? "Manually exploring all insights about " +
                          dataset?.outcome +
                          (retSuccessValue !== undefined ? ` is ${retSuccessValue}` : "")
                        : "Exploring all insights about " +
                          dataset?.outcome +
                          (retSuccessValue !== undefined ? ` is ${retSuccessValue}` : "")}
            </div>
            {isContinuous && !comparisonOptions && (
              <div className={styles.nextTitleTypeSelectWrapper}>
                <div className={styles.nextTitleTypeSelectText}>{"Show"}</div>
                <div className={styles.nextTItleTypeSelect}>
                  <Select
                    id="continuousGraphType"
                    options={[
                      { label: "Averages", value: "AVERAGE" },
                      { label: "Totals", value: "TOTAL" }
                    ]}
                    menuPosition="bottom"
                    value={
                      continuousGraphDisplayType === "TOTAL"
                        ? { label: "Totals", value: "TOTAL" }
                        : { label: "Averages", value: "AVERAGE" }
                    }
                    onChange={(o) => {
                      updateContinuousGraphDisplayType(o.value);
                    }}
                  />
                </div>
              </div>
            )}
            {!isContinuous && !comparisonOptions && (
              <div className={styles.nextTitleTypeSelectWrapper}>
                <div className={styles.nextTitleTypeSelectText}>{"Success"}</div>
                <div className={styles.nextTitleSelect}>
                  <Select
                    id="outcomeSuccessSelect"
                    options={successOptions ?? []}
                    menuPosition="bottom"
                    value={successOptions?.find((option) => {
                      if (datasetSuccess?.value !== undefined) {
                        return option?.value === datasetSuccess?.value;
                      }
                      return option?.value === datasetTargetValue;
                    })}
                    onChange={(val) => {
                      updateDatasetSuccess(val);
                    }}
                  />
                </div>
              </div>
            )}
            {rawHasSuccessChanged && (
              <Button
                type={"primary"}
                onClick={() => {
                  let isConfirmed = confirm(
                    "This change will create a new Sense evaluation of the dataset. You will be automatically redirected to the homepage. \n\nAny unsaved work in this exploration will be lost. Would you like to proceed?"
                  );
                  if (isConfirmed) {
                    copyAndChangeDatasetSuccess(datasetId, datasetSuccess?.value);
                    updateViewType(VIEW_TYPE.DATASETS);
                    history.push("/");
                  }
                }}
                style={{ marginLeft: "10px" }}
              >
                {"Reevaluate Dataset"}
              </Button>
            )}
          </div>

          {!isTransformOpen && (
            <div className={styles.chartsHolder}>
              <AutoSizer>
                {({ height, width }) => {
                  return (
                    <List
                      rowRenderer={(props) => (
                        <ListRow
                          {...props}
                          {...this.props}
                          isContinuous={isContinuous}
                          moreCharts={moreCharts}
                          chartStyle={chartStyle}
                          retSuccessValue={retSuccessValue}
                          hasSuccessChanged={hasSuccessChanged}
                          retCharts={retCharts}
                          isUpdateComparisonPeriod={isUpdateComparisonPeriod}
                          updateIsUpdateComparisonPeriod={updateIsUpdateComparisonPeriod}
                          tempComparisonOptions={tempComparisonOptions}
                          updateTempComparisonOptions={updateTempComparisonOptions}
                          sortType={sortType}
                          updateSortType={updateSortType}
                          displayType={displayType}
                          updateDisplayType={updateDisplayType}
                        />
                      )}
                      width={width}
                      height={height}
                      rowCount={retCharts.length + 1}
                      rowHeight={(props = {}) => {
                        const { index } = props;
                        let min = 500;
                        let max = 700;
                        let viewHeight = height;
                        if (index > 0) {
                          viewHeight = height * 0.9;
                          min = 400;
                          max = 700;
                        } else if (comparisonOptions) {
                          // viewHeight = height + 100;
                          max = 800;
                        }

                        return Math.max(min, Math.min(max, viewHeight));
                      }}
                      scrollToIndex={chartIndex}
                    />
                  );
                }}
              </AutoSizer>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const ListRow = (props = {}) => {
  const {
    index,
    style,

    id,
    runId,
    dataset,
    datasetId,
    projectId,
    project,
    bestCharts,
    hexMap,
    updatePinnedHex,
    updateSelectedHex,
    updateSelectedChart,
    updateHover,
    selectedChart,
    replayActions,
    selectedHex,
    gridType,
    assignTodo,
    updateDrilldownValue,
    datasetSuccess,
    updateDatasetSuccess,
    successOptions,
    datasetTargetValue,

    interactionsEvaluated,

    history,
    copyAndChangeDatasetSuccess,
    updateViewType,

    isReportExpand,
    updateIsReportExpand,

    comparisonOptions,
    openExploration,

    isHeatmapGlobalScale,
    updateIsHeatmapGlobalScale,
    continuousGraphDisplayType,
    updateContinuousGraphDisplayType,
    removeAllNodes,

    isContinuous,
    moreCharts,
    chartStyle,
    retSuccessValue,
    hasSuccessChanged,
    retCharts,

    isUpdateComparisonPeriod,
    updateIsUpdateComparisonPeriod,
    tempComparisonOptions,
    updateTempComparisonOptions,
    updateSortType,
    displayType,
    updateDisplayType
  } = props;

  if (index <= 0) {
    return <MainChart {...props} />;
  }

  const i = index - 1;
  const n = retCharts[i];
  const node = n;

  if (!n) {
    return <React.Fragment />;
  }

  const hKey = n.hKey || node?.chart?.narrative?.title;

  const isSelected = selectedHex && hKey === selectedHex.x + "_" + selectedHex.y;

  const repClass = n.isFakeHidden
    ? styles.reportChartHidden
    : n.isTemporary
      ? styles.reportChartTemporary
      : styles.reportChart;

  const isNumeric = node?.chart?.isNumeric;
  const isSecondOrder = Boolean(node?.chart?.isSecondOrder);

  const sortType = props.sortType ?? (isSecondOrder ? "IMPACT" : isNumeric ? "ALPHABETIC" : "COUNT");

  const expandTempChartStyle = {
    height: "calc(100% - 170px)",
    width: "100%"
  };

  const outcomeLabel = n?.chart?.chart?.yAxis?.label
    ? `${n?.chart?.chart?.yAxis?.label}${isContinuous ? "" : ` (${n?.chart?.chart?.yAxis?.unit})`}`
    : "Outcome";

  const cStyle =
    n.isTemporary && isReportExpand ? expandTempChartStyle : { background: i % 2 !== 0 ? "white" : "#f2f3f7" };
  const retStyle = {
    ...cStyle,
    ...style
  };

  return (
    <div
      id={"reportChart_" + hKey + "_" + (n.nIndex !== undefined ? n.nIndex : 0)}
      key={hKey + "_" + node?.chart?.narrative?.title + "_" + i}
      style={style}
      className={repClass}
      onMouseEnter={() => updateHover(node)}
      onMouseLeave={() => updateHover(undefined)}
    >
      {n.isTemporary && (selectedChart || selectedHex?.chart?.title) ? (
        <div className={styles.tempActions}>
          <div className={styles.sortActions}>
            {!comparisonOptions?.dateField && (
              <SortButtons
                isSecondOrder={isSecondOrder}
                isContinuous={isContinuous}
                sortType={sortType}
                updateSortType={updateSortType}
                outcomeLabel={outcomeLabel}
                node={node}
              />
            )}
          </div>
          <ButtonGroup>
            {/*
              TODO: Implement chart level commenting

            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Feedback"}</div>
                </Popover>
              }
            >
              <Button
                style={{ padding: "3px" }}
                onClick={() =>
                  updateIsCommentModal({
                    aTypeReadable: node?.chart?.title,
                    node: {
                      ...node,
                      id: node?.chart?.title,
                      text: node?.chart?.title,
                    },
                    nextId: id,
                  })
                }
              >
                <img src={TodoFeedbackIcon} />
              </Button>
            </OverlayTrigger>
            */}
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Assign"}</div>
                </Popover>
              }
            >
              <Button
                style={{ padding: "3px" }}
                onClick={() =>
                  assignTodo({
                    node: {
                      ...node,
                      id: node?.chart?.title,
                      text: node?.chart?.title
                    },
                    nextId: id
                  })
                }
              >
                <img src={TodoAssignIcon} />
              </Button>
            </OverlayTrigger>
            {selectedChart && (
              <OverlayTrigger
                placement="top"
                trigger={["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-top">
                    <div>{"Add Chart"}</div>
                  </Popover>
                }
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();

                    return updatePinnedHex(
                      {
                        x: hKey.split("_")[0],
                        y: hKey.split("_")[1]
                      },
                      { ...selectedChart, isSearch: true }
                    );
                  }}
                  style={{ padding: "3px" }}
                >
                  <img src={UnpinnedIcon} className={styles.fPin} />
                </Button>
              </OverlayTrigger>
            )}
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{isReportExpand === true ? "Hide Fullscreen" : "Show Fullscreen"}</div>
                </Popover>
              }
            >
              <Button onClick={() => updateIsReportExpand(!isReportExpand)} style={{ padding: "3px" }}>
                {isReportExpand === true ? "Collapse" : "Expand"}
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Close"}</div>
                </Popover>
              }
            >
              <Button
                style={{ padding: "3px" }}
                onClick={() => {
                  if (isReportExpand) {
                    updateIsReportExpand(false);
                  }
                  if (selectedChart) {
                    return updateSelectedChart(undefined);
                  } else {
                    return updateSelectedHex(selectedHex);
                  }
                }}
                title="Close"
              >
                <div className={styles.selIcon}>
                  <img src={NextClose} />
                </div>
              </Button>
            </OverlayTrigger>
          </ButtonGroup>
        </div>
      ) : (
        <div className={styles.reportCenter}>
          <div className={styles.sortActions}>
            {!comparisonOptions?.dateField && (
              <SortButtons
                isSecondOrder={isSecondOrder}
                isContinuous={isContinuous}
                sortType={sortType}
                updateSortType={updateSortType}
                outcomeLabel={outcomeLabel}
                node={node}
              />
            )}
          </div>
          <ButtonGroup>
            {/*

            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Center Chart"}</div>
                </Popover>
              }
            >
              <Button
                onClick={() =>
                  nextReducer.centerHex(
                    { x: n.x, y: n.y },
                    false,
                    false
                  )
                }
                style={{ padding: "3px" }}
              >
                <FontAwesomeIcon
                  icon={faMapMarker}
                  className={styles.fPin}
                />
              </Button>
            </OverlayTrigger>
          */}
            {/*
              TODO: Implement chart level commenting

            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Feedback"}</div>
                </Popover>
              }
            >
              <Button
                style={{ padding: "3px" }}
                onClick={() =>
                  updateIsCommentModal({
                    aTypeReadable: node?.chart?.title,
                    node: {
                      ...node,
                      id: node?.chart?.title,
                      text: node?.chart?.title,
                    },
                    nextId: id,
                  })
                }
              >
                <img src={TodoFeedbackIcon} />
              </Button>
            </OverlayTrigger>
            */}
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Assign"}</div>
                </Popover>
              }
            >
              <Button
                style={{ padding: "3px" }}
                onClick={() =>
                  assignTodo({
                    node: {
                      ...node,
                      id: node?.chart?.title,
                      text: node?.chart?.title
                    },
                    nextId: id
                  })
                }
              >
                <img src={TodoAssignIcon} />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Show How This Was Added"}</div>
                </Popover>
              }
            >
              <Button onClick={() => replayActions(node?.chart)} style={{ padding: "3px" }}>
                <FontAwesomeIcon icon={faPlay} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{"Unpin Chart"}</div>
                </Popover>
              }
            >
              <Button onClick={() => removeAllNodes(node)} style={{ padding: "3px" }} className={styles.pinButton}>
                <img src={PinnedHoverIcon} className={styles.pinHover} />
                <img src={PinnedIcon} className={styles.pinNoHover} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top">
                  <div>{isReportExpand === true ? "Hide Fullscreen" : "Show Fullscreen"}</div>
                </Popover>
              }
            >
              <Button onClick={() => updateIsReportExpand(!isReportExpand, node)} style={{ padding: "3px" }}>
                {isReportExpand === true ? "Collapse" : "Expand"}
              </Button>
            </OverlayTrigger>
          </ButtonGroup>
        </div>
      )}
      {node.type === nextReducer.HEXAGON_NODES.VOTING_CHART && node?.chart?.chart?.series?.[0]?.type == "HeatMap" ? (
        <div className={styles.innerChart} style={{ padding: "20px" }}>
          <Heatmap
            style={chartStyle}
            chart={node.chart}
            node={n}
            isReport={true}
            replayActions={replayActions}
            project={project}
            runId={runId}
            projectId={projectId}
            updateDrilldownValue={updateDrilldownValue}
            isHeatmapGlobalScale={isHeatmapGlobalScale}
            updateIsHeatmapGlobalScale={updateIsHeatmapGlobalScale}
          />
        </div>
      ) : node.chart ? (
        <div className={styles.innerChart}>
          <NextChartContainer
            id={id}
            projectId={projectId}
            chart={node.chart}
            style={chartStyle}
            node={n}
            isReport={true}
            showTooltip={true}
            showLeakage={true}
            reportChartSort={sortType}
            isReportExpand={isReportExpand}
          />
          {moreCharts && moreCharts.length > 0 && isSelected && !n.isTemporary && (
            <div className={styles.seeMore}>
              {"See More:"}
              <div>
                {moreCharts.map((node, i) => (
                  <a key={i} className={styles.chartLink} onClick={() => updateSelectedHex(node)}>
                    {node.chart.title}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : node.fields && Object.keys(node.fields).length === 2 ? (
        <div className={styles.innerChart}>
          <DoubleOutcomeChartContainer
            id={id}
            isReport={true}
            fields={hexMap?.[hKey]?.fields}
            colorOne={colors?.[hexMap?.[hKey]?.fields?.[0]?.rank]}
            colorTwo={colors?.[hexMap?.[hKey]?.fields?.[1]?.rank]}
          />
        </div>
      ) : node.fields && Object.keys(node.fields).length === 1 ? (
        <div className={styles.innerChart}>
          <OutcomeChartContainer
            id={id}
            isReport={true}
            field={node.fields[0]}
            color={colors[node.fields[0].rank]}
            chart={{ chartType: "BAR" }}
            style={chartStyle}
          />
        </div>
      ) : (
        <div key={hKey + "_" + i} />
      )}
    </div>
  );
};

const SortButtons = (props = {}) => {
  const { isSecondOrder, isContinuous, sortType, updateSortType, outcomeLabel, node } = props;

  return (
    <ButtonGroup>
      {isSecondOrder && !isContinuous && (
        <OverlayTrigger
          placement="top"
          trigger={["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top">
              <div>{"Sort by Impact"}</div>
            </Popover>
          }
        >
          <Button
            style={{ padding: "3px" }}
            onClick={() => {
              updateSortType("IMPACT");
            }}
            active={sortType === "IMPACT"}
          >
            <div className={styles.selIcon}>
              <FontAwesomeIcon icon={faChartLine} />
            </div>
          </Button>
        </OverlayTrigger>
      )}
      <OverlayTrigger
        placement="top"
        trigger={["hover"]}
        rootClose
        overlay={
          <Popover id="popover-positioned-top">
            <div>{"Sort by " + outcomeLabel}</div>
          </Popover>
        }
      >
        <Button
          style={{ padding: "3px" }}
          onClick={() => {
            updateSortType("OUTCOME");
          }}
          active={sortType === "OUTCOME"}
        >
          <div className={styles.selIcon}>
            <FontAwesomeIcon icon={faBullseye} />
          </div>
        </Button>
      </OverlayTrigger>
      {!(node.type === nextReducer.HEXAGON_NODES.VOTING_CHART && node?.chart?.chart?.series?.[0]?.type == "HeatMap") &&
      node?.chart ? (
        <OverlayTrigger
          placement="top"
          trigger={["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top">
              <div>{"Sort by Count"}</div>
            </Popover>
          }
        >
          <Button
            style={{ padding: "3px" }}
            onClick={() => {
              updateSortType("COUNT");
            }}
            active={sortType === "COUNT"}
            title="Toggle Sort"
          >
            <div className={styles.selIcon}>
              <FontAwesomeIcon icon={faSortNumericDown} />
            </div>
          </Button>
        </OverlayTrigger>
      ) : (
        <React.Fragment />
      )}
      <OverlayTrigger
        placement="top"
        trigger={["hover"]}
        rootClose
        overlay={
          <Popover id="popover-positioned-top">
            <div>{"Sort by Label"}</div>
          </Popover>
        }
      >
        <Button
          style={{ padding: "3px" }}
          onClick={() => {
            updateSortType("ALPHABETIC");
          }}
          active={sortType === "ALPHABETIC"}
          title="Toggle Sort"
        >
          <div className={styles.selIcon}>
            <FontAwesomeIcon icon={faSortAlphaDown} />
          </div>
        </Button>
      </OverlayTrigger>
    </ButtonGroup>
  );
};

const BestCharts = (props = {}) => {
  const { dataset, bestCharts, handleChartLink, updateHover, comparisonOptions } = props;

  if (comparisonOptions) {
    return <div />;
  }

  const chartValues = bestCharts?.map((c) => c.score);
  const chartSummary = getSummary(chartValues);

  const mean = chartSummary.getMean();
  const std = chartSummary.getStandardDeviation();
  const buckets = ["a very weak", "a weak", "a significant", "a strong", "a very strong"];

  const getQualifier = (chart, i) => {
    const bucketIndex = Math.max(0, Math.min(4, std > 0 ? Math.round((chart.score - mean) / std) + 2 : 2));
    return buckets[bucketIndex];
    // switch (i) {
    //   case 0:
    //     return "the strongest";

    //   case 1:
    //     return "the second strongest";

    //   case 2:
    //     return "the third strongest";

    //   default:
    //     return "a strong";
    // }
  };

  const renderOtherRelated = (otherRelatedCharts) => {
    const othersByCondition = {};

    for (let chart of otherRelatedCharts) {
      (othersByCondition[chart.narrative.conditionsLabel] ??= []).push(chart);
    }

    return (
      <span>
        {Object.keys(othersByCondition).map((conditions, i) => (
          <span key={i}>
            {othersByCondition[conditions].map((column, j) => (
              <span key={j}>
                {j === 0 ? "" : " or "}
                <span
                  className={styles.relatedChartLink}
                  onMouseEnter={() => updateHover(column)}
                  onMouseLeave={() => updateHover(undefined)}
                  onClick={() => handleChartLink(column)}
                >
                  {column?.narrative.columnLabel}
                </span>
              </span>
            ))}
            {` behave${othersByCondition[conditions].length > 1 ? "" : "s"} most differently when ${conditions}. `}
          </span>
        ))}
      </span>
    );
  };

  return (
    <div className={styles.bestCharts}>
      {bestCharts.map((top, i) => {
        const relCharts = top.relatedCharts ? top.relatedCharts.filter((related, j) => j <= 2) : [];

        return (
          <div className={styles.topChart} key={i}>
            <span
              className={styles.relatedChartLink}
              onMouseEnter={() => updateHover(top)}
              onMouseLeave={() => updateHover(undefined)}
              onClick={() => handleChartLink(top)}
            >
              {i + 1 + ". " + top?.title}
            </span>
            <span>{" has " + getQualifier(top, i) + " relationship with " + dataset?.outcome + "."}</span>
            {relCharts && relCharts.length > 0 && (
              <span>
                <span>
                  {" The " +
                    (relCharts.length === 1
                      ? ""
                      : relCharts.length === 2
                        ? "two"
                        : relCharts.length === 3
                          ? "three"
                          : "") +
                    " largest behavior differences for "}
                </span>
                <span
                  className={styles.relatedChartLink}
                  onMouseEnter={() => updateHover(top)}
                  onMouseLeave={() => updateHover(undefined)}
                  onClick={() => handleChartLink(top)}
                >
                  {top?.title}
                </span>
                <span>{" occur when "}</span>
                {relCharts.map((related, j) => (
                  <span key={j}>
                    <span
                      className={styles.relatedChartLink}
                      onMouseEnter={() => updateHover(related)}
                      onMouseLeave={() => updateHover(undefined)}
                      // TODO: Super hacky fix this later
                      onClick={() => handleChartLink(related)}
                    >
                      {related?.metadata?.type === "ModelDriver" && related?.narrative?.title
                        ? related?.narrative?.title.replace(" (Model Drivers)", "")
                        : related?.narrative.conditionsLabel}
                    </span>
                    {j === relCharts.length - 2 ? (
                      <span>{", and "}</span>
                    ) : j < relCharts.length - 2 ? (
                      <span>{", "}</span>
                    ) : j === relCharts.length - 1 ? (
                      <span>{"."}</span>
                    ) : (
                      <span />
                    )}
                  </span>
                ))}
              </span>
            )}

            {/*

          {top.relatedCharts.length > 0 && (
            <span>
              {` and it behaves most differently when: `}
              {top.relatedCharts.map((related, j) => (
                <span key={j}>
                  {j === 0 ? "" : " or "}
                  <span
                    className={styles.relatedChartLink}
                    onMouseEnter={() => updateHover(related)}
                    onMouseLeave={() => updateHover(undefined)}
                    // TODO: Super hacky fix this later
                    onClick={() => handleChartLink(related)}
                  >
                    {related?.narrative.conditionsLabel}
                  </span>
                </span>
              ))}
            </span>
          )}
          {"."}
          {top.otherRelatedCharts?.length > 0 &&
            renderOtherRelated(top.otherRelatedCharts)}

          */}
          </div>
        );
      })}
    </div>
  );
};

const MainChart = (props = {}) => {
  const {
    index,
    style,

    id,
    runId,
    dataset,
    datasetId,
    projectId,
    project,
    bestCharts,
    hexMap,
    updatePinnedHex,
    updateSelectedHex,
    updateSelectedChart,
    updateHover,
    selectedChart,
    replayActions,
    selectedHex,
    gridType,
    assignTodo,
    updateDrilldownValue,
    datasetSuccess,
    updateDatasetSuccess,
    successOptions,
    datasetTargetValue,

    interactionsEvaluated,

    history,
    copyAndChangeDatasetSuccess,
    updateViewType,

    isReportExpand,
    updateIsReportExpand,

    comparisonOptions,
    openExploration,
    createExploration,

    isHeatmapGlobalScale,
    updateIsHeatmapGlobalScale,
    continuousGraphDisplayType,
    updateContinuousGraphDisplayType,
    removeAllNodes,

    isContinuous,
    moreCharts,
    chartStyle,
    retSuccessValue,
    hasSuccessChanged,
    retCharts,

    isUpdateComparisonPeriod,
    updateIsUpdateComparisonPeriod,
    tempComparisonOptions,
    updateTempComparisonOptions,
    updateSortType,
    displayType,
    updateDisplayType
  } = props;

  const comparisonOptionsHasChanged =
    tempComparisonOptions?.referenceStart !== comparisonOptions?.referenceStart ||
    tempComparisonOptions?.referenceEnd !== comparisonOptions?.referenceEnd ||
    tempComparisonOptions?.currentStart !== comparisonOptions?.currentStart ||
    tempComparisonOptions?.currentEnd !== comparisonOptions?.currentEnd;

  return (
    <div className={styles.reportMainChartWrapper} style={style}>
      {/* <div className={styles.nextTitle}>
        <div className={styles.nextTitleText}>
          {comparisonOptions
            ? "Exploring What's Changed about " +
              dataset?.outcome +
              (successOptions?.find((option) => {
                if (datasetSuccess?.value !== undefined) {
                  return option?.value === datasetSuccess?.value;
                }
                return option?.value === datasetTargetValue;
              })?.value
                ? ` is ${
                    successOptions?.find((option) => {
                      if (datasetSuccess?.value !== undefined) {
                        return option?.value === datasetSuccess?.value;
                      }
                      return option?.value === datasetTargetValue;
                    })?.value
                  }`
                : "")
            : gridType === "Default"
            ? "Exploring all insights about " +
              dataset?.outcome +
              (retSuccessValue !== undefined
                ? ` is ${retSuccessValue}`
                : "")
            : gridType === "Reduced"
            ? "The top 6 variables that affect " +
              dataset?.outcome +
              (retSuccessValue !== undefined
                ? ` is ${retSuccessValue}`
                : "")
            : gridType === "ModelDriver"
            ? "The top variables that affect my model"
            : gridType === "Empty"
            ? "Manually exploring all insights about " +
              dataset?.outcome +
              (retSuccessValue !== undefined
                ? ` is ${retSuccessValue}`
                : "")
            : "Exploring all insights about " +
              dataset?.outcome +
              (retSuccessValue !== undefined
                ? ` is ${retSuccessValue}`
                : "")}
        </div>
        {isContinuous && !comparisonOptions && (
          <div className={styles.nextTitleTypeSelectWrapper}>
            <div className={styles.nextTitleTypeSelectText}>{"Show"}</div>
            <div className={styles.nextTItleTypeSelect}>
              <Select
                id="continuousGraphType"
                options={[{ label: "Averages", value: "AVERAGE" }, { label: "Totals", value: "TOTAL"}]}
                menuPosition="bottom"
                value={continuousGraphDisplayType === "TOTAL" ? { label: "Totals", value: "TOTAL"} : { label: "Averages", value: "AVERAGE"}}
                onChange={(o) => {
                  updateContinuousGraphDisplayType(o.value);
                }}
              />
            </div>
          </div>
        )}
        {!isContinuous && !comparisonOptions && (
          <div className={styles.nextTitleSelect}>
            <Select
              id="outcomeSuccessSelect"
              options={successOptions ?? []}
              menuPosition="bottom"
              value={successOptions?.find((option) => {
                if (datasetSuccess?.value !== undefined) {
                  return option?.value === datasetSuccess?.value;
                }
                return option?.value === datasetTargetValue;
              })}
              onChange={(val) => {
                updateDatasetSuccess(val);
              }}
            />
          </div>
        )}
        {hasSuccessChanged && (
          <Button
            type={"primary"}
            onClick={() => {
              let isConfirmed = confirm(
                "This change will create a new Sense evaluation of the dataset. You will be automatically redirected to the homepage. \n\nAny unsaved work in this exploration will be lost. Would you like to proceed?"
              );
              if (isConfirmed) {
                copyAndChangeDatasetSuccess(
                  datasetId,
                  datasetSuccess?.value
                );
                updateViewType(VIEW_TYPE.DATASETS);
                history.push("/");
              }
            }}
            style={{ marginLeft: "10px" }}
          >
            {"Reevaluate Dataset"}
          </Button>
        )}
      </div> */}
      {interactionsEvaluated && !comparisonOptions ? (
        <div className={styles.nextSubtitle + " " + styles.nextMainChartComboCount} id="comboCount">
          <div className={styles.exploreCombinationBadge}>
            <Icon size={18} src={RadarIcon} />
            <div
              style={{
                marginLeft: "6px",
                paddingRight: "6px",
                lineHeight: "10px"
              }}
            >
              <strong>{numeral(interactionsEvaluated).format("0,0")}</strong>
              <span>{" combinations automatically evaluated"}</span>
            </div>
          </div>
          <ButtonGroup>
            <Button
              onClick={() => {
                updateDisplayType("CHART");
              }}
              active={displayType === "CHART"}
            >
              {"Chart"}
            </Button>
            <Button
              onClick={() => {
                updateDisplayType("SUMMARY");
              }}
              active={displayType === "SUMMARY"}
            >
              {"Summary"}
            </Button>
          </ButtonGroup>
        </div>
      ) : (
        <React.Fragment />
      )}
      {comparisonOptions ? (
        <div className={styles.whatsChangedSubheader}>
          <div className={styles.whatsChangedSubheaderText}>
            <strong>
              <DateRangeDisplay
                referenceStart={comparisonOptions?.referenceStart}
                referenceEnd={comparisonOptions?.referenceEnd}
                currentStart={comparisonOptions?.currentStart}
                currentEnd={comparisonOptions?.currentEnd}
              />
            </strong>
            <Button
              type={"secondary"}
              style={{ marginLeft: "20px", flexShrink: "0" }}
              active={isUpdateComparisonPeriod}
              onClick={() => updateIsUpdateComparisonPeriod(!isUpdateComparisonPeriod)}
            >
              <span>{"Update Comparison Period"}</span>
            </Button>
          </div>
          {isUpdateComparisonPeriod && (
            <React.Fragment>
              <div className={styles.whatsChangedSubheaderText} style={{ marginTop: "10px" }}>
                <span>{"Drag the sliders to change the comparison period."}</span>
              </div>
              <div className={styles.whatsChangedSubheaderSlider}>
                {comparisonOptionsHasChanged && (
                  <div className={styles.whatsChangedSubheaderSliderActions}>
                    <Button
                      type={"secondary"}
                      onClick={() => {
                        updateTempComparisonOptions({
                          ...comparisonOptions
                        });
                      }}
                      style={{ marginLeft: "20px", padding: "9px" }}
                    >
                      <Icon type={"undo"} size={13} />
                    </Button>
                    <Button
                      type={"primary"}
                      onClick={() => {
                        const datasetSuccessOption = successOptions?.find((option) => {
                          if (datasetSuccess?.value !== undefined) {
                            return option?.value === datasetSuccess?.value;
                          }
                          return option?.value === datasetTargetValue;
                        });
                        createExploration({
                          ...comparisonOptions,
                          ...tempComparisonOptions
                        });
                        // openExploration(
                        //   datasetId,
                        //   {
                        //     value: datasetSuccessOption,
                        //     label: datasetSuccessOption?.value,
                        //   },
                        //   {
                        //     ...comparisonOptions,
                        //     ...tempComparisonOptions,
                        //   }
                        // );
                      }}
                      style={{ marginLeft: "10px" }}
                    >
                      {"Update Insights"}
                    </Button>
                  </div>
                )}
                <SmallDateChart
                  datasetId={dataset?.id}
                  comparisonOptions={tempComparisonOptions}
                  updateComparisonOptions={updateTempComparisonOptions}
                  field={dataset?.fields?.[comparisonOptions?.dateField]}
                  hideChart
                  hideText
                  style={{
                    minWidth: "300px",
                    marginTop: "0px"
                  }}
                />
              </div>
            </React.Fragment>
          )}
        </div>
      ) : (
        <React.Fragment />
      )}
      {displayType === "SUMMARY" ? (
        bestCharts && bestCharts.length > 0 && <BestCharts {...props} />
      ) : (
        <React.Fragment>
          <div
            className={styles.reportMuscle + " " + (comparisonOptions ? styles.comparisonChartHolder : "")}
            style={
              comparisonOptions && isUpdateComparisonPeriod
                ? {
                    maxWidth: "450px",
                    maxHeight: "450px"
                  }
                : {}
            }
          >
            {comparisonOptions ? (
              <ComparisonChartContainer id={id} isReportMuscle isNextReport isReportExpand={isReportExpand} />
            ) : (
              <LeakageChartContainer id={id} isFixSvg isReportMuscle isNextReport isReportExpand={isReportExpand} />
            )}
          </div>
          {comparisonOptions ? (
            <div className={styles.whatsChangedTooltipWrapper}>
              <Icon type={"info"} size={13} />
              <div className={styles.whatsChangedTooltipText}>
                {
                  "The area for each variable is calculated from the total absolute change for each value since your selected date"
                }
              </div>
            </div>
          ) : (
            <React.Fragment />
          )}
        </React.Fragment>
      )}
    </div>
  );
};
